export const useCartWithSubdomainLogic = (): ReturnType<typeof useCart> => {
  const subdomain = useSubdomain()
  const { isEmbedded, eventDescriptionIdParam } = useEmbeddedCheckout()

  const cartKey = computed(() => {
    if (isEmbedded.value && eventDescriptionIdParam.value) {
      return `embedded-booking-${eventDescriptionIdParam.value}`
    }

    return subdomain.value || 'general-instance'
  })

  return useCart(cartKey.value)
}
